import React from "react";
import PropTypes from "prop-types";
import { Card, CardImg, CardBody, Badge, CardTitle } from "reactstrap";

const SubjectCards = ({ title, img }) => {
  return (
    <Card className="subject-card rounded">
      <CardImg
        top
        className="rounded-top"
        width="100%"
        src={require("../../../../assets/img/" + img)}
        alt=" "
      />
      <CardBody className="rounded-bottom">
        <CardTitle>{title}</CardTitle>
      </CardBody>
    </Card>
  );
};

SubjectCards.propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
};

export default SubjectCards;
